/** @format */

import {Box, styled, TableBody, TableContainer, TableHead, Typography} from '@mui/material';

import PrimaryMediumButton from 'components/buttons/PrimaryMediumButton';

export const StyledTableContainer = styled(TableContainer)(({theme}) => ({
  backgroundColor: theme.palette.figma_gray_light_1?.main,
  boxShadow: 'none',
  borderRadius: 0,
  '& .MuiTable-root': {
    backgroundColor: theme.palette.figma_gray_light_1?.main,
  },
}));

export const StyledTableHead = styled(TableHead)(({theme}) => ({
  '& .MuiTableCell-head': {
    backgroundColor: theme.palette.figma_gray_middle_light?.main,
    color: theme.palette.figma_gray_dark_1?.main,
    fontSize: '14px',
    fontWeight: 700,
    lineHeight: '16px',
    padding: theme.spacing(2, 3),
    border: 'none',
    borderBottom: '1px solid white',
  },
}));

export const StyledTableBody = styled(TableBody)(({theme}) => ({
  '& .MuiTableRow-root': {
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.02)',
    },
  },
  '& .MuiTableCell-body': {
    color: theme.palette.figma_gray_dark_1?.main,
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '16px',
    padding: theme.spacing(3),
    border: 'none',
    borderBottom: '1px solid transparent',
  },
}));

export const ShowTypeIcon = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  '& .MuiSvgIcon-root': {
    fontSize: '16px',
    color: '#8B8B8B',
  },
}));

export const ActualKPI = styled(Typography)(() => ({
  color: '#EA5759',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '16px',
}));

export const ModalContent = styled(Box)(({theme}) => ({
  paddingBottom: theme.spacing(6),
}));

export const FooterContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  marginTop: theme.spacing(6),
}));

export const FooterText = styled(Typography)(({theme}) => ({
  color: theme.palette.figma_gray_dark_1?.main,
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '16px',
  '& a': {
    color: '#4A9EFF',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
}));

export const ActionButton = styled(PrimaryMediumButton)(({theme}) => ({
  backgroundColor: theme.palette.figma_gray_dark_1?.main,
  color: '#F1F1F1',
  fontSize: '14px',
  fontWeight: 400,
  marginRight: theme.spacing(4),
  padding: theme.spacing(3, 6),
  borderRadius: '8px',
  boxShadow: '1px 1px 5px 0px rgba(0, 0, 0, 0.05)',
  '&:hover': {
    backgroundColor: '#2A2A2A',
  },
}));
